angular.module('olivioConfiguratorApp')
  .factory('ColorSelectService', function ($rootScope, Data) {
    //console.log('init ColorSelectService');

    var colorSelect = {};

    colorSelect.show = function () {
      $rootScope.$broadcast('showColorSelect');
    };
    colorSelect.hide = function () {
      $rootScope.$broadcast('hideColorSelect');
    };
    colorSelect.commit = function () {
      $rootScope.$broadcast('commitColors');
    };

    colorSelect.colors = Data.colorSelectOptions;
    colorSelect.metalColors = Data.metalColorSelectOptions;
    colorSelect.outsideColors = Data.outsideColorSelectOptions;
    colorSelect.woodColors = Data.woodColorSelectOptions;

    colorSelect.selectedColor1 = colorSelect.colors[0];
    colorSelect.selectedColor2 = colorSelect.colors[0];
    colorSelect.selectedColor3 = colorSelect.colors[0];

    return colorSelect;
  });


angular.module('olivioConfiguratorApp')
  .controller('ColorSelectCtrl', function ($scope, Model, Data, ColorSelectService, StepService) {
    //console.log('init ColorSelectCtrl');

    $scope.OLIVIO = OLIVIO;
    $scope.model = Model.model;
    $scope.data = Data;
    $scope.isVisible = false;
    $scope.service = ColorSelectService;

    $scope.getCurrentStep = StepService.getCurrentStep;
    //$scope.getCurrentStep = function() {
    //  console.log('ColorSelectCtrl.getCurrentStep: ', StepService.getCurrentStep());
    //  return StepService.getCurrentStep();
    //};

    $scope.$on('showColorSelect', function () {
      $scope.service.selectedColor1 = $scope.data.getColorSelectOption($scope.model.design.colorIds.mast);
      $scope.service.selectedColor2 = $scope.data.getColorSelectOption($scope.model.design.colorIds.inlay);
      $scope.service.selectedColor3 = $scope.data.getColorSelectOption($scope.model.design.colorIds.lumiere);
      $scope.isVisible = true;
    });
    $scope.$on('hideColorSelect', function () {
      $scope.isVisible = false;
      return false;
    });
    $scope.$on('commitColors', function () {
      $scope.commitColors();
    });


    $scope.closeColorSelect = function () {
      $scope.commitColors();
      $scope.isVisible = false;
    };

    // Drag n drop
    $scope.startCallback = function (event, ui, color) {
      // $scope.draggedColor = color.id;
    };
    $scope.stopCallback = function (event, ui) {
    };
    $scope.dropCallback = function (event, ui) {
      $scope.commitColors();
    };
    $scope.dropCallbackInlay = function (event, ui) {
      console.log('dropCallbackInlay', $scope.service.selectedColor2);
      const c = $scope.service.selectedColor2;
      if(c.wood || c.outsideOnly) {
        // deny wood or special color for inlay
        $scope.service.selectedColor2 = $scope.data.getColorSelectOption($scope.model.design.colorIds.inlay);
      } else {
        $scope.commitColors();
      }
    };
    $scope.dropCallbackLumiere = function (event, ui) {
      const c = $scope.service.selectedColor3;
      if(c.wood) {
        // deny wood for lumiere
        $scope.service.selectedColor3 = $scope.data.getColorSelectOption($scope.model.design.colorIds.lumiere);
      } else {
        $scope.commitColors();
      }
    };
    $scope.overCallback = function (event, ui) {
    };

    $scope.commitColors = function () {
      $scope.model.design.colorIds.mast = $scope.service.selectedColor1.id;
      $scope.model.design.colorIds.inlay = $scope.service.selectedColor2.id;
      $scope.model.design.colorIds.lumiere = $scope.service.selectedColor3.id;
    };
  });
